import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  DropdownItemEl,
  DropdownMenu,
  Trigger,
  Wrapper,
} from "./CategoryDropdown.styles";
import { createPortal } from "react-dom";

const NavDropdown = ({
  label,
  items = [],
  red = false,
  ar = false,
  onSelect,
  onClickCategory,
  category,

  selectedId,
}) => {
  const closeTimer = useRef(null);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });
  const navRef = useRef(null);
  const linkRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!open) return;
    const row = linkRef.current?.closest("[data-categories-row]");
    if (!row) return;
    const handleRowScroll = () => setOpen(false);
    row.addEventListener("scroll", handleRowScroll);
    return () => row.removeEventListener("scroll", handleRowScroll);
  }, [open]);

  const isActive =
    !!selectedId &&
    !!category?.id &&
    (Number(selectedId) === category.id ||
      category?.subcategories?.some((sub) => Number(selectedId) === sub.id));

  useEffect(() => {
    if (open) {
      updatePosition();

      window.addEventListener("scroll", updatePosition, true);
      window.addEventListener("resize", updatePosition);

      return () => {
        window.removeEventListener("scroll", updatePosition, true);
        window.removeEventListener("resize", updatePosition);
      };
    }
  }, [open]);

  const updatePosition = () => {
    if (linkRef.current) {
      const rect = linkRef.current.getBoundingClientRect();
      const dropdownWidth = isMobile ? rect.width : 220;
      const viewportWidth = window.innerWidth;

      let left = rect.left + rect.width / 2 - dropdownWidth / 2;

      // prevent overflow
      if (left + dropdownWidth > viewportWidth - 8) {
        left = viewportWidth - dropdownWidth - 8;
      }
      if (left < 8) {
        left = 8;
      }

      setPosition({
        top: rect.bottom + 7,
        left,
        width: rect.width,
      });
    }
  };

  const handleMouseEnter = () => {
    clearTimeout(closeTimer.current);
    if (items?.length && !isMobile) {
      setOpen(true);
    }
  };

  const handleMouseLeave = () => {
    closeTimer.current = setTimeout(() => setOpen(false), 80);
  };
  const handleTriggerClick = () => {
    if (isMobile && items?.length) {
      setOpen(true);
    } else {
      onClickCategory();
      setOpen(false);
    }
  };

  return (
    <Wrapper onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Trigger
        $red={red}
        $active={isActive || open}
        $show={open}
        onClick={handleTriggerClick}
        ref={linkRef}
      >
        {label}
      </Trigger>
      {open &&
        createPortal(
          <DropdownMenu
            $open={open}
            ref={navRef}
            $left={position.left}
            $top={position.top}
            $width={position.width}
          >
            {items.map((item) => {
              const itemLabel = ar
                ? t(item.nameAr ? item.nameAr : item.name)
                : t(item.name);
              const isActive = item.id === parseInt(selectedId);
              const isRed = item.name === "sale";

              return (
                <DropdownItemEl
                  key={item.id}
                  $active={isActive}
                  $red={isRed}
                  onClick={() => {
                    onSelect(item);
                    setOpen(false);
                  }}
                >
                  {itemLabel}
                </DropdownItemEl>
              );
            })}
          </DropdownMenu>,
          document.body,
        )}
    </Wrapper>
  );
};

export default NavDropdown;
